/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const Search: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd" d="M10 3.625C6.47918 3.625 3.625 6.47918 3.625 10C3.625 13.5208 6.47918 16.375 10 16.375C13.5208 16.375 16.375 13.5208 16.375 10C16.375 6.47918 13.5208 3.625 10 3.625ZM2.375 10C2.375 5.78883 5.78883 2.375 10 2.375C14.2112 2.375 17.625 5.78883 17.625 10C17.625 11.8806 16.9442 13.6022 15.8156 14.9317L21.4419 20.5581C21.686 20.8021 21.686 21.1979 21.4419 21.4419C21.1979 21.686 20.8021 21.686 20.5581 21.4419L14.9317 15.8156C13.6022 16.9442 11.8806 17.625 10 17.625C5.78883 17.625 2.375 14.2112 2.375 10Z"
      fill={color} />
  </svg>
}
